'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _TextInput = require('./TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

var _components = {
	_$SearchInput: {
		displayName: 'SearchInput'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var SearchInput = (function (_Component) {
	_inherits(SearchInput, _Component);

	function SearchInput() {
		_classCallCheck(this, _SearchInput);

		_Component.apply(this, arguments);
	}

	SearchInput.prototype.render = function render() {
		return _react2['default'].createElement(
			'div',
			{ className: 'has-feedback has-feedback-left' },
			_react2['default'].createElement(_TextInput2['default'], _extends({ className: 'form-control' }, this.props)),
			_react2['default'].createElement(
				'div',
				{ className: 'form-control-feedback' },
				_react2['default'].createElement('i', { className: 'fa fa-search' })
			)
		);
	};

	_createClass(SearchInput, null, [{
		key: 'filterDelay',
		value: true,
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			placeholder: 'Hledat'
		},
		enumerable: true
	}]);

	var _SearchInput = SearchInput;
	SearchInput = _wrapComponent('_$SearchInput')(SearchInput) || SearchInput;
	return SearchInput;
})(_Component2['default']);

exports['default'] = SearchInput;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/SearchInput.js
 ** module id = 1019
 ** module chunks = 1
 **/